import MuiBox from "@mui/material/Box";


Box.Column = (props) => <MuiBox display="flex" flexDirection="column" {...props} />;

export default function Box(props) {
	return <MuiBox display="flex" {...props} />;
}